import type { BotSlot, BotStatus } from './types';

export type OnboardingStage = 'no_slot' | 'license_blocked' | 'link_pending' | 'provisioning' | 'ready';

export interface OnboardingState {
  stage: OnboardingStage;
  title: string;
  detail: string;
  canRunActions: boolean;
}

export function onboardingState(slot: BotSlot | null, status: BotStatus | null, mode: 'mock' | 'local' | 'supabase'): OnboardingState {
  if (!slot) {
    return {
      stage: 'no_slot',
      title: 'Cuenta pendiente de asignacion',
      detail: 'Tu cuenta esta creada. El equipo esta preparando tu slot de bot.',
      canRunActions: false
    };
  }

  if (!['active', 'trial'].includes(slot.licenseStatus)) {
    return {
      stage: 'license_blocked',
      title: 'Licencia pendiente',
      detail: 'La licencia de este slot todavia no esta activa.',
      canRunActions: false
    };
  }

  if (!slot.linked) {
    return {
      stage: 'link_pending',
      title: 'Cuenta del juego pendiente',
      detail: 'El slot esta reservado. Falta vincular y validar la cuenta dentro del juego.',
      canRunActions: false
    };
  }

  const provisioning = status?.provisioning;
  if (mode === 'supabase' && (!provisioning || provisioning.status === 'blocked')) {
    return {
      stage: 'provisioning',
      title: 'Preparando servidor',
      detail: provisioning?.detail || provisioning?.label || 'Esperando validacion del agente local.',
      canRunActions: false
    };
  }

  return {
    stage: 'ready',
    title: provisioning?.status === 'warning' ? 'Bot listo con revision pendiente' : 'Bot listo',
    detail:
      provisioning?.status === 'warning'
        ? provisioning.detail || 'El slot puede operar, pero el servidor ha detectado una advertencia de provisioning.'
        : 'El slot esta preparado para recibir acciones.',
    canRunActions: true
  };
}
